import { useEffect, useState } from 'react';

import { useParams } from 'react-router';

import { Box, Typography } from '@mui/material';

import '../../css/Pantalla.css'

const getFechaLocal = ( date: Date ) => {

    const y = date.getFullYear();
    const m = ( date.getMonth() + 1 ).toString().padStart( 2, '0' );
    const d = date.getDate().toString().padStart( 2, '0' );

    return `${y}-${m}-${d}`;
};

export const FechaPage = () => {

    const { align } = useParams();

    const [fechaActual, setFechaActual] = useState(() => {

        const ahora = new Date();

        return { 
            fechaStr: getFechaLocal(ahora), 
            fechaDate: new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate())
        };

    });

    useEffect(() => {

        const timer = setInterval(() => {

            const ahora = new Date();

            const fechaStr = getFechaLocal( ahora );

            if ( fechaStr !== fechaActual.fechaStr ) {            

                setFechaActual({
                    fechaStr,
                    fechaDate: new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate())
                });

            }

        }, 1000);

        return () => clearInterval( timer );

    }, [ fechaActual ]);

    return (
        
        <Box sx={{ color: 'white', p: 4 }}>

            <Box sx={{ textAlign: align ? align : 'center' }}>

                <Typography variant='h4' mt={1}>
                    {
                        fechaActual.fechaDate.toLocaleDateString('es-MX', {
                            weekday: 'long',
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                        })
                    }
                </Typography>

            </Box>

        </Box>     


    );
}